module.exports = __webpack_public_path__ + "img/share-nodes-sharp-light.ba4972d0.svg";